/**
 * Finite game mode: the game ends after `selectedTimeHorizon` clicks.
 * Score is the mean absolute error (MAE) from clicking every 1 second.
 */
export const createFiniteMode = (selectedTimeHorizon) => ({
  initialModeState: {},

  // Finite mode has no extra per-click state to track
  onClickUpdate: (modeState, _timeArray) => modeState,

  isGameOver: ({ clickCount }) => clickCount >= selectedTimeHorizon,

  computeScore: (times) => {
    const differences = times.slice(1).map((time, i) => time - times[i]);
    const absoluteErrors = differences.map(diff => Math.abs(diff - 1000));
    const mae = absoluteErrors.reduce((sum, err) => sum + err, 0) / differences.length;
    const avg = differences.reduce((sum, diff) => sum + diff, 0) / differences.length;
    return { mae, avg, differences, absoluteErrors };
  },
});
